const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  SINGLE_TIME: 'singleTime',
  RANGE_INIT: 'rangeInit',
  DAY_MONTH: 'dayMonth',
  DAY_MONTH_TYPE: 'dayMonthType',
  CONTRAST_DAY: 'contrastDay',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  CHANNEL: 'channel',
  LANGUAGE: 'language',
  TRACKING_DAY: 'trackingDay',
  NETWORK_TYPE: 'networkType',
  MEDIA_CHANNEL: 'mediaChannel',
  IS_INIT: 'isInit',
  SWITCH_DATE_PICKER: 'switchDatePicker',
}

const RESET = 'reset'
const CONTROL = 'control'

const FORM_KEYS = (() => {
  const result = []
  for (const key in FORM_MAP) {
    result.push(FORM_MAP[key])
  }
  return result
})()

const LOCALE_EN = 'en-US'
const LOCALE_CH = 'zh-CN'

export {
    FORM_MAP,
    RESET,
    CONTROL,
    FORM_KEYS,
    LOCALE_EN,
    LOCALE_CH
}
